import { ArrowIcon, Box, Button, Card, Heading, Text, Tooltip } from '@modusign/design-system';
import { ReactNode } from 'react';

interface InPersonInfoCardLayoutProps {
  isLoading?: boolean;
  title: string;
  description: string;
  children: ReactNode;
  buttonText: string;
  disabledMessage: string | null;
  onFooterButtonClicked: () => void;
}

export default function InPersonInfoCardLayout({
  isLoading,
  title,
  description,
  children,
  buttonText,
  disabledMessage,
  onFooterButtonClicked,
}: InPersonInfoCardLayoutProps) {
  return (
    <Card alignItems="center" display="flex" flex={1} flexDirection="column" p={[7, 7, 9]}>
      <Box mb={7} width="100%">
        <Heading fontSize="lg" fontWeight="bold" mb={2}>
          {title}
        </Heading>
        <Text color="textNeutralLight" fontSize="md">
          {description}
        </Text>
      </Box>
      {children}

      <Tooltip
        content={
          <Text fontSize="xs" fontWeight="medium">
            {disabledMessage}
          </Text>
        }
        disabled={!disabledMessage}
        gutter={0}
        placement="bottom"
      >
        <Box position="relative">
          <Button
            disabled={!!disabledMessage}
            isLoading={isLoading}
            mb={4}
            mt={7}
            variant="primary"
            width="200px"
            onClick={onFooterButtonClicked}
          >
            <Box as="span">{buttonText}</Box>
            <ArrowIcon direction="right" ml={1} />
          </Button>
        </Box>
      </Tooltip>
    </Card>
  );
}
